// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.contractContainer.contractual.';

const CONTINUE_CONTRACT = `${DOMAIN}continueContract`;

export { CONTINUE_CONTRACT };